import React from "react";

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

const RowsPerPageSelect = ({ rowsPerPage, onRowsPerPageChange }) => {
  return (
    <div className="d-flex align-items-center justify-content-end gap-2 mb-2">
      <label htmlFor="rowsPerPage" className="form-label fw-bold mb-0 fs-14">
        Rows per page:
      </label>
      <select
        id="rowsPerPage"
        className="form-select form-select-sm"
        style={{ width: "auto" }}
        value={rowsPerPage}
        onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
      >
        {ROWS_PER_PAGE_OPTIONS.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RowsPerPageSelect;
